import React from 'react';

import TemplateContext from './context';

const useTemplate = () => React.useContext(TemplateContext);

export default useTemplate;
